import type { ListItemButtonPropsType } from '~/types/ListItemButton'
import ListItem from './ListItem'

export default function ListItemButton(props: ListItemButtonPropsType) {
  return (
    <ListItem
      button={true}
      selected={props.selected}
      disabled={props.disabled}
      onClick={props.onClick}
      divider={props.divider}
      alignItems={props.alignItems || 'center'}
      class={props.class}
      classList={props.classList}
    >
      {props.children}
    </ListItem>
  )
}
